// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont{
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    padding-right: 40px;
}

.con1{
    background-color: #F4F8F8;
    margin-top: -30px;
    width: 100%;
    padding: 70px;
    
}

.img-cont {
    width: 60%; 
    overflow: hidden; 
    background-color: #F4F8F8;
    ;
  }
  
  .img-cont img {
    width: 100%; 
    height: 100%; 
    object-fit: contain; 
   
  }

  .con2{
    background-color: white;
    margin-left: 20px;
    padding-top: 100px;
    padding-right: 120px;
    padding-left: 60px;
    padding-bottom: 30px;
    margin-top: 0;
  }

.con3{
    background-color: green;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 90px 50px;
    width: 40%;
    color: white;
    gap: 0;
}

.link{
    border: 1px solid white;
    padding: 5px 8px;
    border-radius: 20px;
    width: fit-content;
}

.link2-con{
    display: flex;
    justify-content: flex-start;
}
.link2{
    border: 1px solid green;
    padding: 7px 15px;
    border-radius: 22px;
    color: green;
    font-size: small;
}

.body1{
   padding: 20px 0;
    text-align: justify;
}

.con3 button{
    background-color: white;
    color: green;
    padding: 10px 20px;
    border: 1px solid white;
    border-radius: 25px;
    font-size: small;
    font-weight: 600;
}

.list{
    padding-bottom: 10px;
    text-align: justify;
}

.sec{
    display: flex;
    justify-content: center;
    padding: 40px 0;
}
.con4{
    display: flex;
    justify-content: center;
    gap: 60px;
    align-items:flex-start;
}


.con5-div{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 15px;
    width: 100%;
}

.con5 input, .con5 select, .con5 textarea{
    padding: 5px 10px;
    border-radius: 20px;
    outline: none;
    border: 1px solid #02813763
    
}

.con5 p{
    padding: 5px 0;
}

.con6{
    display: flex;
    flex-direction: row;
    gap: 30px;
    width: 100%;
}

.name-con {
    width: 60%;
}

.gender-con{
    width: 40%;
}


.div-con input, .div-con select{
    width: 100%;
}

.img{
    width: 40%;
}
.con4 img{
    width: 100%; 
    height: 100%; 
    object-fit: contain; 
}

.button-con{
    display: flex;
    width: 100%;
}

.disabled-button {
    text-decoration: line-through;
    color: gray; 
  }


.con4 button{
    border: 1px solid white;
    background-color: green;
    color: white;
    border-radius: 15px;
    padding: 5px 0;
}

.cover{
    color: green;
}


@media screen and (max-width: 1024px) {
    .cont{
        flex-direction: column;
        gap: 10px;
        padding: 0;
    }
    
    .con1{
        padding: 0;  
    }
    
    .img-cont {
        width: 100%; 
        padding: 0;
      }
      
    
      .con2{
       width: 100%;
        padding: 15px;
       margin: 0;
      }
    
    .con3{
        padding: 20px;
        width: 100%;
    }

    .con4{
        display: flex;
        flex-direction: column;
    }
    
    
    .con5 {
        width: 100%;
        padding: 15px;
    }

    
    .img{
        width: 100%;
    }
    

    .sec{
        padding: 20px 0;
    }
    
    .con6{
        display: flex;
        flex-direction: column;
        gap: 8px
    }

    .name-con {
        width: 100%;
    }
    
    .gender-con{
        width: 100%;
    }
 
}`, "",{"version":3,"sources":["webpack://./src/components/Scholarship.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,aAAa;;AAEjB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;;EAE3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;;EAErB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;EACf;;AAEF;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;GACG,eAAe;IACd,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb;;AAEJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,WAAW;EACb;;;AAGF;IACI,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI;QACI,sBAAsB;QACtB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;MACZ;;;MAGA;OACC,WAAW;QACV,aAAa;OACd,SAAS;MACV;;IAEF;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;;IAGA;QACI,WAAW;QACX,aAAa;IACjB;;;IAGA;QACI,WAAW;IACf;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;AAEJ","sourcesContent":[".cont{\n    background-color: white;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 20px;\n    padding-right: 40px;\n}\n\n.con1{\n    background-color: #F4F8F8;\n    margin-top: -30px;\n    width: 100%;\n    padding: 70px;\n    \n}\n\n.img-cont {\n    width: 60%; \n    overflow: hidden; \n    background-color: #F4F8F8;\n    ;\n  }\n  \n  .img-cont img {\n    width: 100%; \n    height: 100%; \n    object-fit: contain; \n   \n  }\n\n  .con2{\n    background-color: white;\n    margin-left: 20px;\n    padding-top: 100px;\n    padding-right: 120px;\n    padding-left: 60px;\n    padding-bottom: 30px;\n    margin-top: 0;\n  }\n\n.con3{\n    background-color: green;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 90px 50px;\n    width: 40%;\n    color: white;\n    gap: 0;\n}\n\n.link{\n    border: 1px solid white;\n    padding: 5px 8px;\n    border-radius: 20px;\n    width: fit-content;\n}\n\n.link2-con{\n    display: flex;\n    justify-content: flex-start;\n}\n.link2{\n    border: 1px solid green;\n    padding: 7px 15px;\n    border-radius: 22px;\n    color: green;\n    font-size: small;\n}\n\n.body1{\n   padding: 20px 0;\n    text-align: justify;\n}\n\n.con3 button{\n    background-color: white;\n    color: green;\n    padding: 10px 20px;\n    border: 1px solid white;\n    border-radius: 25px;\n    font-size: small;\n    font-weight: 600;\n}\n\n.list{\n    padding-bottom: 10px;\n    text-align: justify;\n}\n\n.sec{\n    display: flex;\n    justify-content: center;\n    padding: 40px 0;\n}\n.con4{\n    display: flex;\n    justify-content: center;\n    gap: 60px;\n    align-items:flex-start;\n}\n\n\n.con5-div{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding-bottom: 15px;\n    width: 100%;\n}\n\n.con5 input, .con5 select, .con5 textarea{\n    padding: 5px 10px;\n    border-radius: 20px;\n    outline: none;\n    border: 1px solid #02813763\n    \n}\n\n.con5 p{\n    padding: 5px 0;\n}\n\n.con6{\n    display: flex;\n    flex-direction: row;\n    gap: 30px;\n    width: 100%;\n}\n\n.name-con {\n    width: 60%;\n}\n\n.gender-con{\n    width: 40%;\n}\n\n\n.div-con input, .div-con select{\n    width: 100%;\n}\n\n.img{\n    width: 40%;\n}\n.con4 img{\n    width: 100%; \n    height: 100%; \n    object-fit: contain; \n}\n\n.button-con{\n    display: flex;\n    width: 100%;\n}\n\n.disabled-button {\n    text-decoration: line-through;\n    color: gray; \n  }\n\n\n.con4 button{\n    border: 1px solid white;\n    background-color: green;\n    color: white;\n    border-radius: 15px;\n    padding: 5px 0;\n}\n\n.cover{\n    color: green;\n}\n\n\n@media screen and (max-width: 1024px) {\n    .cont{\n        flex-direction: column;\n        gap: 10px;\n        padding: 0;\n    }\n    \n    .con1{\n        padding: 0;  \n    }\n    \n    .img-cont {\n        width: 100%; \n        padding: 0;\n      }\n      \n    \n      .con2{\n       width: 100%;\n        padding: 15px;\n       margin: 0;\n      }\n    \n    .con3{\n        padding: 20px;\n        width: 100%;\n    }\n\n    .con4{\n        display: flex;\n        flex-direction: column;\n    }\n    \n    \n    .con5 {\n        width: 100%;\n        padding: 15px;\n    }\n\n    \n    .img{\n        width: 100%;\n    }\n    \n\n    .sec{\n        padding: 20px 0;\n    }\n    \n    .con6{\n        display: flex;\n        flex-direction: column;\n        gap: 8px\n    }\n\n    .name-con {\n        width: 100%;\n    }\n    \n    .gender-con{\n        width: 100%;\n    }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
